import { Box, ButtonBase, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import { useReportHubFilters } from "../ReportHubFilterContext";
import { reporthubChartOptions } from "../reports";
import SHModal from "../../../theme/Modal/SHModal";
import Subheading from "../../../theme/text/Subheading";
import { DropdownBaseV2 } from "../../../theme/dropdowns/Dropdown";

import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { ReportFilterDropdownFilter } from "./filter/ReportFilterDropdownFilter";
import { useMemo, useState } from "react";
import { calculateDaysBetween, chartDateOptions, chartDateTimeFrames, chartTypes, normalizeFrame, reportFilterComponentTypes } from "../chartFilterEnums";
import NumberInput from "../../../theme/inputs/NumberInput";
import ShDateRangePicker from "../../../theme/ShDateRangePicker";
import { ReportDetailsPageDetails } from "./ReportDetailsPageDetails";
import { RhDateSelector } from "./RhDateSelector";
import cx from 'classnames';
import Text from "../../../theme/text/Text";

export const MRhSettings = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const handleClose = () => {
        props.handleClose();
    }

    const categorySettings = useMemo(() => {
        return props.filtersRegistry?.chartSettings?.categorySettings?.();
    }, [props.filtersRegistry]);

    // An `all` category stores no values, so the count comes from the caller, which has the list the
    // backend resolved.
    let categorySelectionCount = props.currentReport?.category?.values?.length ?? 0;
    if (props.currentReport?.category?.all) {
        categorySelectionCount = props.categorySelectionCount ?? 0;
    }

    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'popover' : undefined;
    
    const handlePopoverClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    return (
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:3,
                    paddingX:3,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}
            >
                <Subheading>{t("settings")}</Subheading>


                {/* <Text light>The data presented will automatically be filtered through the selected warehouses</Text> */}
            </Box>
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >

                {props.currentReport &&
                    <>
                        <RhDateSelector
                            variant="stacked"
                            currentReport={props.currentReport}
                            setCurrentReport={props.setCurrentReport}
                        />
                        <Box
                            className={cx(undefined,{
                                'is-category':props.currentReport.category?.use
                            })}
                            sx={{
                                display:"flex",
                                justifyContent:"center",
                                flexDirection:'column',
                                borderRadius:5,
                                background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            }}
                        >
                            <ToggleButtonGroup
                                // color={currentReport.category?.use ? "green" : "red"}
                                value={props.currentReport.category?.use}
                                exclusive
                                onChange={(e,value) => {
                                    if(value === null) return;
                                    props.setCurrentReport(prev => {
                                        let nextReport = {
                                            ...prev,
                                            date: {
                                                ...prev.date,
                                                custom:false,
                                            },
                                            category: {
                                                ...prev.category,
                                                use: value,
                                            },
                                            ...(value && { displayType: chartTypes.BAR }),
                                        };
    
                                        // if (value === true) {
                                        //     const settings = props.filtersRegistry?.chartSettings?.categorySettings();
                                        //     if (settings?.defaultDateTime?.custom) {
                                        //         nextReport = {
                                        //             ...nextReport,
                                        //             date: {
                                        //                 ...settings.defaultDateTime,
                                        //             },
                                        //         };
                                        //     }
                                        // }
                                        if (value === true) {
                                            if (categorySettings?.defaultDateTime?.custom) {
                                                nextReport = {
                                                    ...nextReport,
                                                    date: {
                                                        ...categorySettings.defaultDateTime,
                                                    },
                                                };
                                            }
                                        }
    
                                        return nextReport;
                                    });
                                }}

                                aria-label="Active"

                                className={cx(`${props.currentReport.category?.use}`, {
                                    'active': props.currentReport.category?.use 
                                })}
                                sx={{
                                    width:1,
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    borderBottomLeftRadius:0,
                                    borderBottomRightRadius:0,
                                    transition:"250ms",
                                    "&.active" : {
                                        
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton
                                    sx={{
                                        flex:1,
                                        padding: 0,
                                        paddingX: 2,
                                        border: 0,
                                        lineHeight: "32px",
                                        textTransform: "unset",
                                        borderRadius: "32px !important",
                                        color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], 

                                        background: theme.palette.mode === "dark" ? colors.grey[400] :colors.grey[100], 
                                        transition: "250ms",
                                        "&.Mui-selected": {
                                            background: theme.palette.mode === "dark" ? colors.grey[600] :colors.grey[0], 
                                            color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.grey[400], 
                                            fontWeight:"bold",
                                            borderBottomLeftRadius:"0px !important",
                                        },
                                        "&.Mui-selected:hover": {
                                            background:theme.palette.mode === "dark" ? colors.grey[600]: colors.grey[0],
                                        },
                                    }}
                                    value={false}
                                >
                                    {t('use_date')}
                                </ToggleButton>
                                <ToggleButton
                                    sx={{
                                        flex:1,
                                        padding: 0,
                                        paddingX: 2,
                                        border: 0,
                                        lineHeight: "32px",
                                        textTransform: "unset",
                                        borderRadius: "32px !important",
                                        color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], 

                                        background: theme.palette.mode === "dark" ? colors.grey[400] :colors.grey[100], 
                                        transition: "250ms",
                                        "&.Mui-selected": {
                                            background: theme.palette.mode === "dark" ? colors.grey[600] :colors.grey[0], 
                                            color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.grey[400], 
                                            fontWeight:"bold",
                                            borderBottomRightRadius:"0px !important",
                                        },
                                        "&.Mui-selected:hover": {
                                            background:theme.palette.mode === "dark" ? colors.grey[600]: colors.grey[0],
                                        },
                                    }}
                                    value={true}
                                >
                                    {t('use_category')}

                                </ToggleButton>
                            </ToggleButtonGroup>

                            {!(props.currentReport.category?.use && categorySettings?.defaultDateTime?.custom) ? (
                                props.currentReport.category?.use &&
                                <Box
                                    sx={{
                                        p:2,
                                        width:1,
                                    }}
                                >
                                    <ButtonBase
                                        onClick={handlePopoverClick}
                                        sx={{
                                            width:1,
                                            background:
                                                theme.palette.mode === "dark"
                                                ? colors.grey[200]
                                                : colors.grey[400],
                                            height: 32,
                                            borderRadius: 4,
                                            px: 1.5,
                                            pr:props.currentReport.category.key ? 0.5 : 1.5,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            whiteSpace:"nowrap",
                                            gap: 1.5,
                                            color:
                                                theme.palette.mode === "dark"
                                                ? colors.txt.primary
                                                : colors.txt.light,
                                            fontWeight: 500,
                                            fontSize:  14,
                                            fontFamily: "Roboto,sans-serif",
                                        }}
                                    >
                                        {props.currentReport.category.key
                                            ? props.filtersRegistry.filters[props.currentReport.category.key].name
                                            : t("no_key_selected")}

                                        {props.currentReport.category.key && (
                                                <Box
                                                sx={{
                                                    px:1,
                                                    height:24,
                                                    borderRadius:4,
                                                    display:"flex",
                                                    alignItems:'center',
                                                    cursor:"pointer",
                                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                                    "&:hover .rp-value-container" : {
                                                        pr:4,
                                                    },
                                                    "&:hover .rp-value-container .rp-filter-icon" : {
                                                        zIndex:1,
                                                        opacity:1,
                                                            transition:"125ms",
                                                    },
                                                }}
                                            >
                                                {categorySelectionCount > 0 ?
                                                    <>
                                                        <Text noBreak bold>{categorySelectionCount}</Text>
                                                        <Text noBreak light sx={{ml:0.5,}}>
                                                            {t("selected")}
                                                        </Text>
                                                    </>
                                                :
                                                    <Text noBreak>{t("no_selection")}</Text>
                                                }
                                            </Box>
                                        )}
                                    </ButtonBase>
                                </Box>
                            ) : (
                                <>
                                {props.currentReport.category?.use &&
                                    <Box
                                        sx={{
                                            p:2,
                                            width:1,
                                        }}
                                    >
                                        <ButtonBase
                                            onClick={handlePopoverClick}
                                            sx={{
                                                width:1,
                                                background:
                                                    theme.palette.mode === "dark"
                                                    ? colors.grey[200]
                                                    : colors.grey[400],
                                                height: 32,
                                                borderRadius: 4,
                                                px: 1.5,
                                                pr:props.currentReport.category.key ? 0.5 : 1.5,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                whiteSpace:"nowrap",
                                                gap: 1.5,
                                                color:
                                                    theme.palette.mode === "dark"
                                                    ? colors.txt.primary
                                                    : colors.txt.light,
                                                fontWeight: 500,
                                                fontSize:  14,
                                                fontFamily: "Roboto,sans-serif",
                                            }}
                                        >
                                            {props.currentReport.category.key
                                                ? t(props.filtersRegistry.filters[props.currentReport.category.key].name)
                                                : t("no_key_selected")}

                                            {props.currentReport.category.key && (
                                                    <Box
                                                    sx={{
                                                        px:1,
                                                        height:24,
                                                        borderRadius:4,
                                                        display:"flex",
                                                        alignItems:'center',
                                                        cursor:"pointer",
                                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                                        "&:hover .rp-value-container" : {
                                                            pr:4,
                                                        },
                                                        "&:hover .rp-value-container .rp-filter-icon" : {
                                                            zIndex:1,
                                                            opacity:1,
                                                                transition:"125ms",
                                                        },
                                                    }}
                                                >
                                                    {categorySelectionCount > 0 ?
                                                        <>
                                                            <Text noBreak bold>{categorySelectionCount}</Text>
                                                            <Text noBreak light sx={{ml:0.5,}}>
                                                                {t("selected")}
                                                            </Text>
                                                        </>
                                                    :
                                                        <Text noBreak>{t("no_selection")}</Text>
                                                    }
                                                </Box>
                                            )}
                                        </ButtonBase>
                                    </Box>
                                }
                                {/* // We can just render the component out here if it is there */}
                                {categorySettings?.defaultDateTime?.component && (
                                    <categorySettings.defaultDateTime.component
                                        setCurrentReport={props.setCurrentReport}
                                        currentReport={props.currentReport}
                                    />
                                )}
                                </>
                            )}

                            {!props.currentReport?.category?.use && (
                                <Box
                                    sx={{
                                        width:1,
                                        p:2,
                                    }}
                                >
                                    <ToggleButtonGroup
                                        value={props.currentReport.displayType}
                                        exclusive
                                        onChange={(e,value) => {
                                            if(value != null){
                                                props.setCurrentReport(prev => ({
                                                    ...prev,
                                                    displayType:value,
                                                }));
                                            }
                                        }}

                                        aria-label="Active"

                                        className={cx(`${props.currentReport.category?.use}`, {
                                            'active': !props.currentReport.category?.use 
                                        })}
                                        sx={{
                                            width:1,
                                            background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[100],
                                            padding:0.5,
                                            borderRadius:5,
                                            transition:"250ms",
                                            "&.active" : {
                                                // background: colors.grey[200],
                                                transition:"250ms",
                                            },
                                        }}
                                    >
                                        <ToggleButton
                                            sx={{
                                                flex:1,
                                                padding: 0,
                                                paddingX: 2,
                                                border: 0,
                                                lineHeight: "32px",
                                                textTransform: "unset",
                                                borderRadius: "32px !important",
                                                color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], 

                                                background: theme.palette.mode === "dark" ? colors.grey[200] :colors.grey[100], 
                                                transition: "250ms",
                                                "&.Mui-selected": {
                                                    background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0], 
                                                    color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.grey[400], 
                                                    fontWeight:"bold",
                                                },
                                                "&.Mui-selected:hover": {
                                                    background:theme.palette.mode === "dark" ? colors.grey[400]: colors.grey[0],
                                                },
                                            }}
                                            value={chartTypes.BAR}
                                        >
                                            {t('chart_bar')}
                                        </ToggleButton>
                                        <ToggleButton
                                            sx={{
                                                flex:1,
                                                padding: 0,
                                                paddingX: 2,
                                                border: 0,
                                                lineHeight: "32px",
                                                textTransform: "unset",
                                                borderRadius: "32px !important",
                                                color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], 

                                                background: theme.palette.mode === "dark" ? colors.grey[200] :colors.grey[100], 
                                                transition: "250ms",
                                                "&.Mui-selected": {
                                                    background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0], 
                                                    color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.grey[400], 
                                                    fontWeight:"bold",
                                                },
                                                "&.Mui-selected:hover": {
                                                    background:theme.palette.mode === "dark" ? colors.grey[400]: colors.grey[0],
                                                },
                                            }}
                                            value={chartTypes.LINE}
                                        >
                                            {t('chart_line')}
                                        </ToggleButton>
                                        <ToggleButton
                                            sx={{
                                                flex:1,
                                                padding: 0,
                                                paddingX: 2,
                                                border: 0,
                                                lineHeight: "32px",
                                                textTransform: "unset",
                                                borderRadius: "32px !important",
                                                color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], 

                                                background: theme.palette.mode === "dark" ? colors.grey[200] :colors.grey[100], 
                                                transition: "250ms",
                                                "&.Mui-selected": {
                                                    background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0], 
                                                    color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.grey[400], 
                                                    fontWeight:"bold",
                                                },
                                                "&.Mui-selected:hover": {
                                                    background:theme.palette.mode === "dark" ? colors.grey[400]: colors.grey[0],
                                                },
                                            }}
                                            value={chartTypes.AREA}
                                        >
                                            {t('chart_area')}
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </Box>
                            )}
                        </Box>
                    </>
                }
                <ButtonBase
                    onClick={handleClose}
                    sx={{
                        mt:1,
                        width:1,
                        textAlign:"center",
                        lineHeight:'32px',
                        background:theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400],
                        color:theme.palette.mode === "dark" ? colors.txt['primary'] : colors.txt['light'],
                        borderRadius:4,
                        fontWeight:"bold",
                        fontSize:14,
                        fontFamily:"Roboto,sans-serif",
                    }}
                >
                    {t("close")}
                </ButtonBase>
                
            </Box>

            <ReportDetailsPageDetails
                chartOption={props.chartOption}
                currentReport={props.currentReport}
                filtersRegistry={props.filtersRegistry}
                setCurrentReport={props.setCurrentReport}
                id={popoverId}
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                stopPropagation={true}
            />
        </SHModal>
    )
}